import Mixin from './mixin.js'
import Component from './component.vue'

export default {
  install(Vue, options) {
    Vue.mixin(Mixin)
    Vue.component('site-drawer', Component)
  }
};